<div class="reject-order-dialog-container">
    <div class="reject-order-dialog-header-container">
        <div>  <p class="reject-order-dialog-header-text reject-order-section-headers">REJECT ORDER?</p></div>
        <div><p class="reject-order-dialog-sub-heading">You are about to reject this order, are you sure?</p></div>
    </div>

    <div class="reject-order-btn-dialog-container">

        <button class="cancel-reject-order-dialog-btn" mat-flat-button type="button" (click)="cancelReject()">
            <div class="cancel-reject-order-btn-content">
                <span><p class="cancel-reject-order-btn-text">CANCEL</p></span>
            </div>
        </button>

        <button class="reject-order-btn" mat-flat-button type="button"
                (click)="rejectOrder()">
            <div class="reject-order-btn-content">
                <span><p class="reject-order-btn-text">REJECT</p></span>
            </div>
        </button>
    </div>

</div>

